import script from "./BudgetPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BudgetPage.vue?vue&type=script&setup=true&lang=ts"

import "./BudgetPage.vue?vue&type=style&index=0&id=58d511e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d511e8"]])

export default __exports__